import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vpfa-feature-flags-testing-root',
  template: `
    <h1>Feature Flags Testing</h1>
    Test flag is:
    <a *ifFeatureFlagEnabled="'TestFlag'" routerLink="worksWhenTestFlagIsOn">Enabled</a>
    <span *ifFeatureFlagDisabled="'TestFlag'">Disabled</span>
  `,
  styles: [``],
  standalone: false,
})
export class FeatureFlagsTestingRootComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
